import { ITemplateScope } from "AngularFormly";
import { RecordRepeaterController, RowState } from "./controller";
import { RecordEditRepeaterController } from "./editController";

export interface ICopyDeleteScope extends ITemplateScope {
  addRow: (model?: any) => void;
  deleteRow: (model: any) => void;
  moveUp: (model: any) => void;
  moveDown: (model: any) => void;
  edit: (model: any, rowState: RowState) => void;
  editComplete: (model: any, rowState: RowState) => void;
}
export class RecordCopyDeleteController {
  static $inject = ["$scope"];

  constructor($scope: ICopyDeleteScope) {
    const repeaterController: RecordRepeaterController = (<any>(
      $scope.formState
    )).getRepeaterController();
    $scope.addRow = (model) => repeaterController.addRow(model);
    $scope.deleteRow = (model) => repeaterController.deleteRow(model);
    $scope.moveUp = (model) => repeaterController.moveUp(model);
    $scope.moveDown = (model) => repeaterController.moveDown(model);
    $scope.edit = (model) =>
      (<RecordEditRepeaterController>repeaterController)?.edit(model);
    $scope.editComplete = (model) =>
      (<RecordEditRepeaterController>repeaterController)?.editComplete(model);
  }
}
